'use client';
/** @jsxImportSource @emotion/react */

import type { TableProps as MuiTableProps } from '@mui/material/Table';

import MuiTable from '@mui/material/Table';

type ExcludedMuiProps = '';

interface TableProps extends Omit<MuiTableProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { TableProps };
export const Table: React.FC<TableProps> = MuiTable;

Table.displayName = 'Table';
